import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {AdminModel, EditAdminDTO, useAdminById} from '../../../entities';
import * as Yup from 'yup';
import { AxiosError } from 'axios';

type UseAddAdminFormProps = {
  setOpen: (open: boolean) => void;
  adminId: string;
  admin?: AdminModel;
};

export const useEditAdminForm = ({setOpen, adminId, admin}: UseAddAdminFormProps) => {
  const {displayNameSchema} = useSchemes();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateAdminMutation} = useAdminById(adminId);

  const onSubmit = async (values: EditAdminDTO) => {
    setErrorMessage(null);
    try {
      await updateAdminMutation.mutateAsync({adminId, displayName: values.displayName});
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при редактировании администратора');
    }
  };

  const formik = useFormik({
    initialValues: {
      displayName: admin?.displayName || '',
    },
    validationSchema: Yup.object({
      displayName: displayNameSchema,
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: updateAdminMutation.isPending,
    errorMessage,
    submitError: updateAdminMutation.error ? (updateAdminMutation.error as AxiosError<ApiError>).response?.data : undefined,
    submitForm: () => formik.handleSubmit(),
  };
};
